import { FC } from "react";
import {
  Benefit as BenefitType,
  BenefitsSkinProps } from
"@commons-monorepo/index";
import styles from "./benefits-1.module.css";
import WidgetContainer from "../../../widget-container";

const Benefits1: FC<BenefitsSkinProps> = ({
  benefits,
  highLight,
  className
}) => {
  const Benefit: FC<{benefit: BenefitType;}> = ({ benefit }) => {
    return (
      <article className={styles.benefit1}>
        <figure className={styles.icon}>
          <img loading={"lazy"} src={benefit.image} alt={benefit.title} />
        </figure>
        <h3 className={styles.title}>{benefit.title}</h3>
        <div className={styles.description}>
          <p>{benefit.description}</p>
        </div>
      </article>);

  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLight}>

      <section
        className={`${styles.benefits1} ${className || ""}`}
        aria-label='benefits-container'>

        <div className={`${styles.benefits1Container} ${styles.benefit1Grid}`}>
          {benefits.map((benefit, index) =>
          <Benefit benefit={benefit} key={`benefit-${index}`} />
          )}
        </div>
      </section>
    </WidgetContainer>);

};

export default Benefits1;